import React from 'react'
import ContentArea from '../../components/ContentArea'

const Snacks = () => {
    return (

        <ContentArea>
            <h3>Snacks</h3>
            <p><b>Nuts and Seeds:</b> Raw nuts and seeds are by far the most preferred option, particularly walnuts, almonds, and pumpkin seeds. Other good choices include sunflower seeds, pine nuts, flax seeds, and chia seeds (a relative newcomer with high nutritional value).</p>
            <h3>Fruit</h3>
            <p><b>Best Antioxidant Effect: </b>
            Blueberries, raspberries, plums, cherries, red grapes (no more than 10 grapes per serving due to high sugar content).
            </p>
            <p>Citrus fruits, such as oranges and grapefruits, are okay in moderation.</p>

            <p>Some fruits, such as bananas, grapes, and dried fruit have high sugar content, and should be consumed sparingly. </p>
            <h3>Other Healthful Snacks</h3>
            <p><b>Preferred Snacks:</b> Raw vegetables, vegetable-based protein shake, Dr. Dan’s trail mix, soy or almond yogurt, whole grain crackers (Mary’s Gone Crackers and Ryvita are preferred brands), brown rice cakes.</p>

            <p>Spreads and Dips: Hummus, guacamole, almond butter, tahini, tofu spread, and pesto are preferred options for any of the snacks listed above.</p>
            <h3>Healthful Drinks</h3>
            <p>Spring or filtered water, herbal tea, green tea</p>
            <a taget="_blank" href="https://marcusinstitute.jeffersonhealth.org/">Please visit our website for more information</a>
            <hr></hr>

            <p>References:</p>

            <p>Chen Z et al. Plant versus animal based diets and insulin resistance, prediabetes and type 2 diabetes: the Rotterdam Study. Eur J Epidemiol. 2018 Sep; 33(9) 883-893.
            </p>
            <p>Grant, JD. Time for change: Benefits of a plant-based diet. Can Fam Physician. 2017; 63(10) 744-746.</p>

            <p> Huang J, Liao LM, Weinstein SJ, Sinha R, Graubard BI, Albanes D. Association Between Plant and Animal Protein Intake and Overall and Cause-Specific Mortality. JAMA Intern Med. 2020 Sep 1;180(9):1173-1184.</p>

            <p>Monti DA, Bazzan, AJ. Tapestry of Health: Weaving Wellness into your life through the new science of Integrative Medicine.</p>


        </ContentArea>
    )
}

export default Snacks